// 管理アカウント認証情報の localStorage キー。
// ManagementAuthContext（保存/削除の正本）と api.ts のレスポンスインターセプタ（課題117:
// 401でのログイン画面リダイレクト時にクリア）で共有し、キーのドリフトを防ぐための単一定義。
export const MANAGEMENT_TOKEN_KEY = 'management_token';
export const MANAGEMENT_ACCOUNT_KEY = 'management_account';
